<script setup lang="ts">
	import type { NavigationItem} from "~/components/Navigation/index.vue";
	const { gsap } = useGSAP()

	const isDropdownOpen = inject<Ref<boolean>>('headerDropdownOpen')

	const { item, isScrolled } = defineProps<{
		item: NavigationItem,
		isScrolled: boolean
	}>()

	const containerRef = useTemplateRef('containerRef')
	const dropdown = ref<HTMLElement | null>(null)

	const isExpanded = ref(false)
	let tl:any = null

	const initTimeline = ( () => {
		let calcHeight = dropdown.value.clientHeight

		gsap.set(dropdown.value, { height: 0, opacity: 1 })

		tl.clear()
		tl.to(dropdown.value, { height: calcHeight, duration: 0.5, ease: 'power2.inOut' })
	})

	const onEnter = ((e:any) => {
		if (e.pointerType === 'mouse') {
			tl.timeScale(1).play()
			isExpanded.value = true
			 if (isDropdownOpen) {
				 isDropdownOpen.value = true
			 }
		}
	})
	const onLeave = ((e:any) => {
  		if (e.pointerType === 'mouse') {
	  		tl.timeScale(4).reverse()
			isExpanded.value = false
		 	if (isDropdownOpen) {
				 isDropdownOpen.value = false
			 }
		}
	})
	const toggle = (() => {
		if (isExpanded.value) {
			tl.timeScale(4).reverse()
			isExpanded.value = false
			 if (isDropdownOpen) {
				 isDropdownOpen.value = true
			 }
		}else {
			tl.timeScale(1).play()
			isExpanded.value = true
			 if (isDropdownOpen) {
				 isDropdownOpen.value = false
			 }
		}
	})

	onMounted(() => {
		if (!containerRef.value || !dropdown.value) return

		tl = gsap.timeline({ paused: true, reversed: true })

		setTimeout(function(){
			initTimeline()
        }, 200)
	})

	onClickOutside(
		containerRef,
		(event) => {
			if(isExpanded.value) {
				tl.reversed(!tl.reversed())
				isExpanded.value = false
			 	if (isDropdownOpen) {
			 		isDropdownOpen.value = false
			 	}
			}
		},
	)
</script>

<template>
	<span ref="containerRef" class="my-auto relative">
		<span class="relative flex flex-col" @click="toggle" @pointerenter="onEnter" @pointerleave="onLeave">
			<NuxtLink v-if="item" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}"
					  class="leading-none relative font-normal text-[1.1rem] lg:text-[1.15rem] xl:text-[1.25rem] whitespace-nowrap transition duration-500 ease-in-out"
					  :title="item.title" no-prefetch
			>
				{{ item.label }}
			</NuxtLink>
			<span ref="dropdown" class="absolute top-full left-0.5 opacity-0 overflow-hidden">
				<span class="border-l-primary border-l-[5px] bg-white block" :class="{ '[@media(max-width:1060px)]:pt-6.5 pt-6.75 xl:pt-7.5 2xl:pt-8 [@media(min-width:2100px)]:pt-10': !isScrolled, '[@media(max-width:1060px)]:pt-5 pt-5.25 xl:pt-5.25 2xl:pt-5.5 [@media(min-width:2100px)]:pt-6': isScrolled }">
					<span v-if="item.children?.length" class="flex flex-col gap-5 2xl:gap-5.5 px-3 py-4 bg-white -mt-6.5">
						<NuxtLink v-for="item in item.children" :key="item.id" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}, query: item.query ? item.query : {}}"
							  class="leading-none relative font-thin text-[1rem] whitespace-nowrap transition duration-500 ease-in-out"
							  :title="item.title" no-prefetch
						>
							{{ item.label }}
						</NuxtLink>
					</span>
					<ServiceAreaNavigationDropdownItems v-else-if="item.slug === 'leistungen'" />
				</span>
			</span>
		</span>
	</span>
</template>
